import { put, takeEvery } from "redux-saga/effects";
import * as types from "../types";

function* setLoader(action) {
  yield put({ type: types.UPDATE_LOADER, payload: action.payload });
}

function* loaderSaga() {
  yield takeEvery(types.SET_LOADER, setLoader);
}

export default loaderSaga;
